import { DateRangeValue } from '@hub-components';
import { BenchmarkSelection } from 'app/hub-components/components/benchmarks/benchmarks.component';

export const DEFAULT_DATE_INTERVAL: DateRangeValue = {
  dynamic: { title: 'Last Month', name: 'last', num: 1, unit: 'month' },
  type: 'dynamic',
  range: 'Last Month',
};

export const COMPARISON_OPTIONS = [
  { name: 'None', value: 'none' },
  { name: 'Previous Period', value: 'previous_period' },
  { name: 'Previous Year(s)', value: 'previous_year' },
  { name: 'Custom Period', value: 'custom' },
];

export const DEFAULT_COMPARE_TO: BenchmarkSelection = { name: 'None', value: 'none' };

export const DEFAULT_WIDGET_HEIGHT = 270;

export const WIDGET_SIZE_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
];

export const WIDGET_TYPES = {
  KPI: 'kpi',
  KPI_LINE: 'kpi-line',
  SPLINE_BAR: 'spline-bar',
  PIE: 'pie',
  LINE: 'line',
  MAP: 'map',
};

export const WIDGET_TYPE_OPTIONS = [
  { label: 'KPI', value: WIDGET_TYPES.KPI },
  { label: 'KPI Line', value: WIDGET_TYPES.KPI_LINE },
  { label: 'Spline Bar', value: WIDGET_TYPES.SPLINE_BAR },
  { label: 'Pie', value: WIDGET_TYPES.PIE },
  { label: 'Line', value: WIDGET_TYPES.LINE },
  { label: 'Map', value: WIDGET_TYPES.MAP },
];

export const MAP_TYPES = {
  WORLD_ROBINSON: 'custom/world-robinson',
  ASIA: 'custom/asia',
  EUROPE: 'custom/europe',
  US_ALL: 'countries/us/us-all',
  CANADA: 'countries/ca/ca-all',
  NETHERLANDS: 'countries/nl/nl-all',
  BELGIUM: 'countries/be/be-all',
  US_ZIP_CODES_BY_STATE: 'us-zip-codes-by-state',
};

export const MAP_OPTIONS = [
  { value: MAP_TYPES.WORLD_ROBINSON, name: 'World' },
  { value: MAP_TYPES.ASIA, name: 'Asia' },
  { value: MAP_TYPES.EUROPE, name: 'Europe' },
  { value: MAP_TYPES.BELGIUM, name: 'Belgium' },
  { value: MAP_TYPES.CANADA, name: 'Canada' },
  { value: MAP_TYPES.NETHERLANDS, name: 'Netherlands' },
  { value: MAP_TYPES.US_ALL, name: 'USA' },
  { value: MAP_TYPES.US_ZIP_CODES_BY_STATE, name: 'US State' },
];

export const COUNTRY_SPECIFIC_MAPS = [MAP_TYPES.BELGIUM, MAP_TYPES.CANADA, MAP_TYPES.NETHERLANDS, MAP_TYPES.US_ALL, MAP_TYPES.US_ZIP_CODES_BY_STATE];

export const STATE_SPECIFIC_MAPS = [MAP_TYPES.US_ZIP_CODES_BY_STATE];

export const CUSTOM_MAPS = [MAP_TYPES.WORLD_ROBINSON, MAP_TYPES.ASIA, MAP_TYPES.EUROPE];

export const NL_REGIONS_DEFINITIONS = {
  'north brabant': 'Noord-Brabant',
  'north holland': 'Noord-Holland',
  'south holland': 'Zuid-Holland',
};

export const BE_REGIONS_DEFINITIONS = {
  'province of namur': 'Namur',
};

export const CA_REGIONS_DEFINITIONS = {
  'quebec': 'Québec',
};

export const COUNTRIES_DEFINITIONS = {
  'united states': 'United States of America',
  'tanzania': 'United Republic of Tanzania',
  "cote d'ivoire": 'Ivory Coast',
};

export const CLOUD_FRONT_ZIP_CODES_US_BASE_URL = 'https://d3biq4ajz6xuo3.cloudfront.net/highcharts-maps/zip-codes/us/';

export const US_STATE_MAP_PATHS = {
  'alabama': 'al_alabama_zip_codes_geo.min',
  'alaska': 'ak_alaska_zip_codes_geo.min',
  'arizona': 'az_arizona_zip_codes_geo.min',
  'arkansas': 'ar_arkansas_zip_codes_geo.min',
  'california': 'ca_california_zip_codes_geo.min',
  'colorado': 'co_colorado_zip_codes_geo.min',
  'connecticut': 'ct_connecticut_zip_codes_geo.min',
  'delaware': 'de_delaware_zip_codes_geo.min',
  'district of columbia': 'dc_district_of_columbia_zip_codes_geo.min',
  'florida': 'fl_florida_zip_codes_geo.min',
  'georgia': 'ga_georgia_zip_codes_geo.min',
  'hawaii': 'hi_hawaii_zip_codes_geo.min',
  'idaho': 'id_idaho_zip_codes_geo.min',
  'illinois': 'il_illinois_zip_codes_geo.min',
  'indiana': 'in_indiana_zip_codes_geo.min',
  'iowa': 'ia_iowa_zip_codes_geo.min',
  'kansas': 'ks_kansas_zip_codes_geo.min',
  'kentucky': 'ky_kentucky_zip_codes_geo.min',
  'louisiana': 'la_louisiana_zip_codes_geo.min',
  'maine': 'me_maine_zip_codes_geo.min',
  'maryland': 'md_maryland_zip_codes_geo.min',
  'massachusetts': 'ma_massachusetts_zip_codes_geo.min',
  'michigan': 'mi_michigan_zip_codes_geo.min',
  'minnesota': 'mn_minnesota_zip_codes_geo.min',
  'mississippi': 'ms_mississippi_zip_codes_geo.min',
  'missouri': 'mo_missouri_zip_codes_geo.min',
  'montana': 'mt_montana_zip_codes_geo.min',
  'nebraska': 'ne_nebraska_zip_codes_geo.min',
  'nevada': 'nv_nevada_zip_codes_geo.min',
  'new hampshire': 'nh_new_hampshire_zip_codes_geo.min',
  'new jersey': 'nj_new_jersey_zip_codes_geo.min',
  'new mexico': 'nm_new_mexico_zip_codes_geo.min',
  'new york': 'ny_new_york_zip_codes_geo.min',
  'north carolina': 'nc_north_carolina_zip_codes_geo.min',
  'north dakota': 'nd_north_dakota_zip_codes_geo.min',
  'ohio': 'oh_ohio_zip_codes_geo.min',
  'oklahoma': 'ok_oklahoma_zip_codes_geo.min',
  'oregon': 'or_oregon_zip_codes_geo.min',
  'pennsylvania': 'pa_pennsylvania_zip_codes_geo.min',
  'rhode island': 'ri_rhode_island_zip_codes_geo.min',
  'south carolina': 'sc_south_carolina_zip_codes_geo.min',
  'south dakota': 'sd_south_dakota_zip_codes_geo.min',
  'tennessee': 'tn_tennessee_zip_codes_geo.min',
  'texas': 'tx_texas_zip_codes_geo.min',
  'utah': 'ut_utah_zip_codes_geo.min',
  'vermont': 'vt_vermont_zip_codes_geo.min',
  'virginia': 'va_virginia_zip_codes_geo.min',
  'washington': 'wa_washington_zip_codes_geo.min',
  'west virginia': 'wv_west_virginia_zip_codes_geo.min',
  'wisconsin': 'wi_wisconsin_zip_codes_geo.min',
  'wyoming': 'wy_wyoming_zip_codes_geo.min',
};

export const MAP_TO_DEFINITIONS = {
  [MAP_TYPES.NETHERLANDS]: NL_REGIONS_DEFINITIONS,
  [MAP_TYPES.BELGIUM]: BE_REGIONS_DEFINITIONS,
  [MAP_TYPES.CANADA]: CA_REGIONS_DEFINITIONS,
};

export const DEFAULT_BREAKDOWN_BORDER_COLOR = 'rgba(0, 0, 0, 0.2)';
export const DEFAULT_BREAKDOWN_TEXT_COLOR = 'rgba(0, 0, 0, 0.6)';

export const EXPORT_INFO = {
  image: {
    success: [
      {
        severity: 'success',
        title: 'Screenshot ready',
        description: '',
        icon: 'fa fa-download',
      },
    ],
    error: [
      {
        severity: 'error',
        title: 'Screenshot failed',
        description: '',
        icon: 'fa fa-exclamation-triangle',
      },
    ],
    exporting: [
      {
        severity: 'info',
        title: 'Generating screenshot',
        description: 'Your screenshot is being generated and you will be notified when it is ready for download.',
        icon: '',
      },
    ],
  },
  excel: {
    success: [
      {
        severity: 'success',
        title: 'Report ready',
        description: '',
        icon: 'fa fa-download',
      },
    ],
    error: [
      {
        severity: 'error',
        title: 'Report failed',
        description: '',
        icon: 'fa fa-exclamation-triangle',
      },
    ],
    exporting: [
      {
        severity: 'info',
        title: 'Generating report',
        description: 'Your Excel export is being generated and you will be notified when it is ready for download.',
        icon: '',
      },
    ],
  },
};

export const BREAKDOWN_INDENTATION = 12;

export const DEFAULT_LIMIT = 100;

export const MAX_ARRANGEABLE_VALUES = 50;

export const DEFAULT_COLORPICKER_COLOR = 'bcc3cd';
